module.exports = __webpack_public_path__ + "static/media/dcc1212-30a.97c53d8d.jpg";